<div nz-row nzType="flex">
    <div nz-col nzSpan="6">
        <div class="formname">{{formTitle}}</div>
    </div>

    <div nz-col nzSpan="18" style="display: flex; justify-content: flex-end;">
        <form nz-form [nzLayout]="'inline'">
            <!-- <nz-form-item>
                <nz-radio-group name="radioValue" [(ngModel)]="radioValue"
                    (ngModelChange)="changeRadioButton($event,true)" nzButtonStyle="solid">
                    <label nz-radio-button nzValue="A">Today's</label>
                    <label nz-radio-button nzValue="B">Yesterday's</label>
                    <label nz-radio-button nzValue="C">Last 7 Days</label>
                    <label nz-radio-button nzValue="D">Last Month</label>
                    <label nz-radio-button nzValue="E">Current Month</label>
                </nz-radio-group>
            </nz-form-item> -->
            <nz-form-item>
                <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
                    <input type="text" name="search" autocomplete="off" nz-input placeholder="Search by User"
                        [(ngModel)]="searchText" />
                </nz-input-group>

                <ng-template #suffixIconButton>
                    <button nz-button name="button1" id="button1" nzType="primary"
                        (click)="getAllProjectWiseHoursDetails(true)" nzSearch><i nz-icon nzType="search"></i></button>
                </ng-template>
            </nz-form-item>
            <!-- <nz-form-item>
                <button nz-button nzType="primary" (click)="importInExcel()"><i nz-icon nzType="file-excel"
                        nzTheme="outline"></i></button>
            </nz-form-item> -->
            <nz-form-item>
                <nz-date-picker nzAllowClear="false" name="date1111" nzFormat="dd/MM/yyyy" [(ngModel)]="ENQUIRY_DATE"   (ngModelChange)="getAllProjectWiseHoursDetailss($event)" ></nz-date-picker>
              
            </nz-form-item>
            <!-- <nz-form-item>
                <button nz-button [nzType]="isFilterApplied" (click)="showFilter()"><i nz-icon
                        nzType="filter"></i></button>
            </nz-form-item> -->

            
        </form>
    </div>
</div>

<!-- <div nz-row>
    <div nz-col nzSpan="24">
        <div class="filter {{filterClass}}">
            <div class="filter-box">
                <form nz-form>
                    <div nz-row nzGutter="16">
                        <div nz-col nzSpan="7">
                            <div nz-row>
                                <div nz-col nzSpan="24">
                                    <nz-form-label nzNoColon><b>Date</b></nz-form-label>

                                    <nz-input-group>
                                        <div nz-row>
                                            <div nz-col nzSpan="12">
                                                <nz-date-picker style="width: 100%;" nzFormat="dd/MM/yyyy"
                                                    name="startDate" (nzOnOpenChange)="startDateHandle($event)"
                                                    [(ngModel)]="START_DATE">
                                                </nz-date-picker>
                                            </div>

                                            <div nz-col nzSpan="12">
                                                <nz-date-picker #endDatePicker style="width: 100%;"
                                                    nzFormat="dd/MM/yyyy" name="endDate"
                                                    [nzDisabledDate]="disabledEndDate" [(ngModel)]="END_DATE">
                                                </nz-date-picker>
                                            </div>
                                        </div>
                                    </nz-input-group>
                                </div>

                                <div nz-col nzSpan="24">
                                    <nz-form-label nzNoColon><b>Actions</b></nz-form-label>

                                    <nz-input-group>
                                        <nz-radio-group name="radioValue" [(ngModel)]="radioValue"
                                            (ngModelChange)="changeRadioButton($event,false)" nzButtonStyle="solid">
                                            <label nz-radio-button nzValue="A">Today's</label>
                                            <label nz-radio-button nzValue="B">Yesterday's</label>
                                            <label nz-radio-button nzValue="C">Last 7 Days</label>
                                            <label nz-radio-button nzValue="D">Last Month</label>
                                            <label nz-radio-button nzValue="E">Current Month</label>
                                        </nz-radio-group>
                                    </nz-input-group>
                                </div>
                            </div>
                        </div>

                        <div nz-col nzSpan="17">
                            <nz-form-label nzNoColon><b>Users</b></nz-form-label>

                            <nz-input-group>
                                <nz-select style="width: 100%;" name="moduleAssigneeName" nzMode="multiple" nzShowSearch
                                    nzAllowClear [(ngModel)]="MODULE_ASSIGNEE_ID">
                                    <nz-option nzCustomContent *ngFor="let assignee of newAssigneeList"
                                        [nzValue]="assignee.ID" [nzLabel]="assignee.NAME">
                                        <div>
                                            {{assignee.NAME}}
                                        </div>

                                        <div style="font-size: 12px; color: gray; text-align: right;">
                                            <span>~&nbsp;{{assignee.TASK_CATEGORY_NAME}}</span>
                                        </div>
                                    </nz-option>
                                </nz-select>
                            </nz-input-group>
                        </div>

                     
                        <div nz-col nzSpan="10">
                            <nz-form-label nzNoColon><b>Project</b></nz-form-label>

                            <nz-input-group>
                                <nz-select name="projectName" style="width: 100%;" nzMode="multiple" nzShowSearch
                                    nzAllowClear style="width: 100%" [(ngModel)]="projectID">
                                    <nz-option *ngFor="let project of projectList" [nzValue]="project.ID"
                                        [nzLabel]="project.NAME"></nz-option>
                                </nz-select>
                            </nz-input-group>
                        </div>

                        <div nz-col nzSpan="7">
                            <nz-form-label nzNoColon><b>Actions</b></nz-form-label><br />

                            <nz-button-group nzSize="default">
                                <button style="margin-right: 10px;" nz-button nzType="primary"
                                    (click)="getAllProjectWiseHoursDetails(true)" nzJustify="end">
                                    <i nz-icon nzType="filter"></i>Apply Filter
                                </button>

                                <button nz-button nzType="primary" (click)="clearFilter()">
                                    <i nz-icon nzType="filter"></i>Clear Filter
                                </button>
                            </nz-button-group>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div> -->

<div nz-row>
    <div nz-col nzSpan="24">
        <nz-table class="my-scroll no-wrap1" nzBordered #table nzShowSizeChanger [nzFrontPagination]="false"
            [nzData]="projectData" [nzLoading]="loadingRecords" [nzTotal]="totalRecords" [(nzPageIndex)]="pageIndex"
            [(nzPageSize)]="pageSize" (nzQueryParams)="sort($event)" >

            <!-- <thead>
                <tr>
                    <th></th>
                    <th  nzWidth="150px" *ngFor="let column of projectList" nzColumnKey="{{column.NAME}}"
                        [nzSortFn]="true"><b>{{column.NAME}}</b></th>
                   
                </tr>
            </thead>

            <tbody>
                <tr  style="cursor: pointer;" nzWidth="150px" *ngFor="let column of assigneeList">{{column.NAME}}
                   
                </tr>
            </tbody> -->
            <thead>
                <tr>
                    <th  *ngFor="let column of columns" nzColumnKey="{{column[0]}}"
                        [nzSortFn]="true"><b>{{column[1]}}</b></th>
                  
                    <th  *ngFor="let day of projectList"><b>{{day.NAME}}</b></th>
                </tr>
            </thead>

            <tbody>
                <tr *ngFor="let data of table.data" style="cursor: pointer;">
                    <td   *ngFor="let column of columns">{{data[column[0]]}}</td>
                    
                    <td  *ngFor="let day of projectList">
                        <!-- <nz-tag nzColor="warning"><p style="margin-bottom: 2px;" *ngFor="let a of splitt(data[day.SHORT_NAME]);let i=index;">{{i+1}}. {{a}}</p></nz-tag>  -->
                       <p *ngFor="let a of splitt(data[day.SHORT_NAME]);let i=index;"> 
                        <nz-tag nzColor="processing" style="margin-bottom: 3px;    border: 1px solid;
                        padding-left: 5px;
                        padding-right: 5px;" > {{i+1}}. {{a}}</nz-tag>
                      </p>
                    </td>
                </tr>
            </tbody>
        </nz-table>
    </div>
</div>